<div
  class="flex-col fixed top-0 bottom-0 z-20 hidden lg:flex items-stretch shrink-0 w-(--sidebar-width) dark [--kt-drawer-enable:true] lg:[--kt-drawer-enable:false]"
  data-kt-drawer="true"
  data-kt-drawer-class="kt-drawer kt-drawer-start flex top-0 bottom-0"
  data-kt-drawer-disable-body-scroll="true"
  data-kt-drawer-enable="true"
  data-kt-drawer-overlay="true"
  data-kt-drawer-width="270px"
  id="sidebar"
  [class.sidebar-hidden]="collapsed()"
>
  <div class="flex flex-col gap-2.5" id="sidebar_header">
    <div class="flex items-center gap-2.5 px-3.5 h-[70px]">
      <a routerLink="/" class="shrink-0">
        <img
          src="assets/media/idb_logo.png"
          alt="Frida logo"
          class="h-8 w-auto"
        />
      </a>

      <div class="flex items-center justify-between grow min-w-0">
        <div class="min-w-0">
          <div class="kt-menu-label cursor-pointer text-mono font-medium grow justify-between">
          <span class="text-lg font-medium text-foreground uppercase grow">
           Frida
          </span>
         </div>
        </div>
        <button
          type="button"
          class="sidebar-toggle-btn"
          (click)="onCollapse()"
          aria-label="Collapse sidebar"
          title="Collapse sidebar"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="3" y="4" width="18" height="16" rx="3" stroke="currentColor" stroke-width="1.6" />
            <path d="M9.5 4.75v14.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            <path d="M16.25 9.5 13.75 12l2.5 2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="flex items-stretch grow shrink-0 justify-center my-5" id="sidebar_menu">
    <div
      class="kt-scrollable-y-auto grow"
      data-kt-scrollable="true"
      data-kt-scrollable-dependencies="#sidebar_header"
      data-kt-scrollable-height="auto"
      data-kt-scrollable-offset="0px"
      data-kt-scrollable-wrappers="#sidebar_menu"
    >
      <div class="mb-5">
        <div
          class="kt-menu flex flex-col w-full gap-1.5 px-3.5"
          data-kt-menu="true"
          data-kt-menu-accordion-expand-all="false"
          id="sidebar_primary_menu"
        >
          <div class="kt-menu-item">
            <a
              class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60 !menu-item-here:bg-transparent"
              routerLink="/"
              routerLinkActive="kt-menu-item-active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="kt-menu-icon items-start text-lg text-secondary-foreground kt-menu-item-active:text-mono">
                <i class="ki-filled ki-home-3"></i>
              </span>
              <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                Pending Items
              </span>
            </a>
          </div>

          <div class="sidebar-section" role="group" aria-labelledby="instruments-heading">
            <div id="instruments-heading" class="sidebar-section-heading">
              <i class="ki-filled ki-bank" aria-hidden="true"></i>
              <span>Instruments</span>
            </div>
            <div class="sidebar-section-items flex flex-col gap-px">
              <div class="kt-menu-item">
                <a
                  class="kt-menu-link py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60"
                  routerLink="/bonds"
                  routerLinkActive="kt-menu-item-active"
                >
                  <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                    Bonds
                  </span>
                </a>
              </div>
              <div class="kt-menu-item">
                <a
                  class="kt-menu-link py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60"
                  routerLink="/swaps"
                  routerLinkActive="kt-menu-item-active"
                >
                  <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                    Swaps
                  </span>
                </a>
              </div>
              <div class="kt-menu-item">
                <a
                  class="kt-menu-link py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60"
                  routerLink="/discount-notes"
                  routerLinkActive="kt-menu-item-active"
                >
                  <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                    Discount Notes
                  </span>
                </a>
              </div>
              <div class="kt-menu-item">
                <a
                  class="kt-menu-link py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60"
                  routerLink="/called-bonds"
                  routerLinkActive="kt-menu-item-active"
                >
                  <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                    Called Bonds
                  </span>
                </a>
              </div>
              <div class="kt-menu-item">
                <a
                  class="kt-menu-link py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60"
                  routerLink="/repurchased-bonds"
                  routerLinkActive="kt-menu-item-active"
                >
                  <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                    Repurchased Bonds
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="kt-menu-item">
            <a
              class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60 !menu-item-here:bg-transparent"
              routerLink="/invoices"
              routerLinkActive="kt-menu-item-active"
            >
              <span class="kt-menu-icon items-start text-lg text-secondary-foreground kt-menu-item-active:text-mono">
                <i class="ki-filled ki-dollar"></i>
              </span>
              <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                Invoices
              </span>
            </a>
          </div>

          <div class="kt-menu-item">
            <a
              class="kt-menu-link gap-2.5 py-2 px-2.5 rounded-md kt-menu-item-active:bg-accent/60 kt-menu-link-hover:bg-accent/60 !menu-item-here:bg-transparent"
              routerLink="/catalogs"
              routerLinkActive="kt-menu-item-active"
            >
              <span class="kt-menu-icon items-start text-lg text-secondary-foreground kt-menu-item-active:text-mono">
                <i class="ki-filled ki-folder"></i>
              </span>
              <span class="kt-menu-title text-sm text-foreground font-medium kt-menu-item-active:text-mono">
                Catalogs
              </span>
            </a>
          </div>
        </div>
      </div>

      <div class="sidebar-user-wrap">
        <div class="sidebar-user-card" title="{{ userName() }} · {{ userEmail() }}">
          <div class="sidebar-user-avatar">
            @if (userPhotoUrl()) {
              <img [src]="userPhotoUrl()" [alt]="userName()" (error)="onPhotoError()" />
            } @else {
              <span>{{ userInitials() }}</span>
              <i class="ki-filled ki-user" aria-hidden="true"></i>
            }
            <span class="sidebar-user-status" aria-label="Signed in"></span>
          </div>
          <div class="sidebar-user-copy">
            <div class="sidebar-user-name">{{ userName() }}</div>
            <div class="sidebar-user-email">{{ userEmail() || 'Authenticated user' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>